<div class="tag-selector">
  <mat-form-field appearance="outline" subscriptSizing="dynamic" class="tag-select-field">
    <mat-label>{{ "shared.tag-selector.label" | translate }}</mat-label>
    <mat-select
      [value]="selectedTag()"
      (selectionChange)="selectedTag.set($event.value)"
      [placeholder]="'shared.tag-selector.placeholder' | translate"
      panelClass="tag-selector-panel">
      @if (allowNone()) {
        <mat-option [value]="null" class="empty-option">{{ "generic.none" | translate }}</mat-option>
      }
      @for (tag of availableTags(); track tag) {
        <mat-option [value]="tag">{{ tag }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  @if (allowCreate() && !isCreating()) {
    <button type="button" mat-button class="create-tag-button" (click)="startCreating()">
      <mat-icon>add</mat-icon>
      {{ "shared.tag-selector.create-new" | translate }}
    </button>
  }

  @if (allowCreate() && isCreating()) {
    <div class="create-tag-form">
      <div class="create-tag-input-row">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="create-tag-input">
          <mat-label>{{ "shared.tag-selector.new-tag-label" | translate }}</mat-label>
          <input
            matInput
            type="text"
            aria-label="Tag name"
            [title]="'shared.tag-selector.new-tag-label' | translate"
            [formControl]="newTagControl"
            [placeholder]="'shared.tag-selector.new-tag-placeholder' | translate"
            (keydown)="onKeyDown($event)"
            autofocus />
        </mat-form-field>

        <div class="create-tag-actions">
          <span [matTooltip]="confirmDisabledTooltipKey() | translate" [matTooltipDisabled]="canConfirm()">
            <button
              type="button"
              mat-icon-button
              class="confirm-button"
              [disabled]="!canConfirm()"
              [matTooltip]="'generic.add' | translate"
              [matTooltipDisabled]="!canConfirm()"
              (click)="confirmCreate()">
              @if (isSaving()) {
                <mat-spinner diameter="18" />
              } @else {
                <mat-icon>check</mat-icon>
              }
            </button>
          </span>
          <button type="button" mat-icon-button [matTooltip]="'generic.cancel' | translate" (click)="cancelCreating()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>

      @if (validationErrorKey()) {
        <mat-error class="create-tag-error">{{ validationErrorKey() | translate }}</mat-error>
      }
    </div>
  }
</div>
